import React, { Component } from 'react';

import { promiseReadFile, ReadFile } from '../promiseReadFile';

interface Props {
  onChange: (pFile: readonly Promise<ReadFile>[]) => void | Promise<void>;
  id?: string;
  hide: boolean;
  multiple?: boolean;
  accept: string;
  labelText?: string;
}

export class SelectFile extends Component<Props> {
  fileInput: HTMLInputElement | null = null;

  onUpload: React.ReactEventHandler<HTMLInputElement> = (event) => {
    if (event.currentTarget.files && event.currentTarget.files.length > 0) {
      const pFiles = Array.from(event.currentTarget.files).map(promiseReadFile);
      this.props.onChange(pFiles);
    }
    this.fileInput!.value = '';
  };

  click = () => {
    this.fileInput!.click();
  };

  render() {
    const id = this.props.id || `fileinput${crypto.randomUUID()}`;
    const hide = this.props.hide ? 'none' : '';

    return (
      <div className="select-file" style={{ display: hide }}>
        <input
          className="hidden"
          type="file"
          id={id}
          multiple={!!this.props.multiple}
          accept={this.props.accept}
          onChange={(ev) => this.onUpload(ev)}
          ref={(element) => {
            this.fileInput = element;
          }}
        />
        <label htmlFor={id}>{this.props.labelText}</label>
      </div>
    );
  }
}
